import { createContext } from 'react';

interface FormPanelContextData {
  formState: {
    data: any;
    errors: any;
    refreshKey?: number;
  };
  formDispatch: ({ type, payload }: { type: string; payload: any }) => void;
  refreshForm: () => void;
}

const FormPanelContext = createContext({} as FormPanelContextData);

export default FormPanelContext;
